import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import { staffAPI } from '../api';
import api from '../api';

const fmtDate = (d) => d ? new Date(d).toLocaleDateString('tr-TR') : '—';
const fmt = (n) => '₺' + parseFloat(n||0).toLocaleString('tr-TR', {minimumFractionDigits:2});

const emptyStaff = {
  first_name:'', last_name:'', tc_no:'', birth_date:'', phone:'', email:'',
  address:'', position:'', department:'', start_date:'', salary:'', salary_currency:'TRY',
  bank_name:'', iban:'', emergency_name:'', emergency_phone:'', notes:'', status:'active'
};

export default function Staff() {
  const { currentFirm } = useAuth();
  const [staff, setStaff] = useState([]);
  const [selected, setSelected] = useState(null);
  const [payments, setPayments] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [showPayForm, setShowPayForm] = useState(false);
  const [form, setForm] = useState(emptyStaff);
  const [editId, setEditId] = useState(null);
  const [payForm, setPayForm] = useState({ amount:'', period:'', pay_date: new Date().toISOString().slice(0,10), notes:'' });
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');

  const flash = (m) => { setMsg(m); setTimeout(()=>setMsg(''),3000); };

  const load = useCallback(async () => {
    if (!currentFirm) return;
    const r = await staffAPI.getAll(currentFirm.id);
    setStaff(r.data);
  }, [currentFirm]);

  useEffect(() => { load(); }, [load]);

  const loadPayments = async (id) => {
    const r = await staffAPI.getPayments(currentFirm.id, id);
    setPayments(r.data);
  };

  const selectStaff = (s) => { setSelected(s); loadPayments(s.id); setShowPayForm(false); };

  const openNew = () => { setForm(emptyStaff); setEditId(null); setShowForm(true); setSelected(null); };
  const openEdit = (s) => {
    setForm({ first_name:s.first_name||'', last_name:s.last_name||'', tc_no:s.tc_no||'', birth_date:s.birth_date?.slice(0,10)||'', phone:s.phone||'', email:s.email||'', address:s.address||'', position:s.position||'', department:s.department||'', start_date:s.start_date?.slice(0,10)||'', salary:s.salary||'', salary_currency:s.salary_currency||'TRY', bank_name:s.bank_name||'', iban:s.iban||'', emergency_name:s.emergency_name||'', emergency_phone:s.emergency_phone||'', notes:s.notes||'', status:s.status||'active' });
    setEditId(s.id); setShowForm(true);
  };

  const saveStaff = async (e) => {
    e.preventDefault(); setSaving(true);
    try {
      if (editId) { await staffAPI.update(currentFirm.id, editId, form); }
      else { await staffAPI.create(currentFirm.id, form); }
      setShowForm(false); setEditId(null); load(); flash('Personel kaydedildi.');
    } catch(err) { flash(err.response?.data?.error||'Hata'); }
    finally { setSaving(false); }
  };

  const deleteStaff = async (id) => {
    if (!window.confirm('Personeli silmek istiyor musunuz?')) return;
    await staffAPI.delete(currentFirm.id, id);
    setSelected(null); load(); flash('Personel silindi.');
  };

  const addPayment = async (e) => {
    e.preventDefault(); setSaving(true);
    try {
      await staffAPI.addPayment(currentFirm.id, selected.id, payForm);
      setPayForm({ amount:'', period:'', pay_date: new Date().toISOString().slice(0,10), notes:'' });
      setShowPayForm(false); loadPayments(selected.id); flash('Ödeme eklendi.');
    } catch(err) { flash(err.response?.data?.error||'Hata'); }
    finally { setSaving(false); }
  };

  const deletePayment = async (payId) => {
    if (!window.confirm('Ödemeyi silmek istiyor musunuz?')) return;
    await api.delete(`/firms/${currentFirm.id}/staff/${selected.id}/payments/${payId}`);
    loadPayments(selected.id); flash('Ödeme silindi.');
  };

  const inp = { height:34, padding:'0 10px', border:'1px solid var(--border)', borderRadius:'var(--radius)', fontSize:13, background:'var(--bg2)', color:'var(--text)', width:'100%' };
  const lbl = { fontSize:11, color:'var(--text2)', marginBottom:4, fontWeight:500 };

  if (!currentFirm) return <div style={{padding:'2rem',color:'var(--text3)',textAlign:'center'}}>Firma seçin.</div>;

  return (
    <div style={{display:'flex',gap:16,minHeight:'70vh'}}>
      {/* Sol: Liste */}
      <div style={{width:260,flexShrink:0,display:'flex',flexDirection:'column',gap:10}}>
        <button onClick={openNew} className="btn btn-dark" style={{width:'100%'}}>+ Personel Ekle</button>
        {msg && <div style={{padding:'6px 10px',borderRadius:'var(--radius)',background:'var(--green-bg)',color:'var(--green)',fontSize:12}}>✓ {msg}</div>}
        <div style={{display:'flex',flexDirection:'column',gap:6}}>
          {staff.map(s => (
            <div key={s.id} onClick={()=>selectStaff(s)}
              style={{background:selected?.id===s.id?'var(--blue-bg)':'var(--bg2)',border:`1px solid ${selected?.id===s.id?'var(--blue-border)':'var(--border)'}`,borderRadius:'var(--radius-lg)',padding:'10px 12px',cursor:'pointer'}}>
              <div style={{fontSize:13,fontWeight:500,color:selected?.id===s.id?'var(--blue-light)':'var(--text)'}}>{s.first_name} {s.last_name}</div>
              <div style={{fontSize:11,color:'var(--text3)',marginTop:2}}>{s.position||'—'} {s.department?`· ${s.department}`:''}</div>
              <div style={{fontSize:11,color:'var(--green)',marginTop:2}}>{s.salary?fmt(s.salary):''}</div>
            </div>
          ))}
          {staff.length===0 && <div style={{textAlign:'center',padding:'2rem',color:'var(--text3)',fontSize:12}}>Personel yok.</div>}
        </div>
      </div>

      {/* Sağ: Detay / Form */}
      <div style={{flex:1,display:'flex',flexDirection:'column',gap:12}}>
        {/* Personel Formu */}
        {showForm && (
          <div className="card">
            <div style={{fontSize:14,fontWeight:600,marginBottom:16}}>{editId?'Personel Düzenle':'Yeni Personel'}</div>
            <form onSubmit={saveStaff}>
              <div style={{marginBottom:12}}>
                <div style={{fontSize:11,color:'var(--text3)',fontWeight:600,textTransform:'uppercase',marginBottom:8}}>Kişisel Bilgiler</div>
                <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:10}}>
                  <div><div style={lbl}>Adı *</div><input value={form.first_name} onChange={e=>setForm(f=>({...f,first_name:e.target.value}))} style={inp} required/></div>
                  <div><div style={lbl}>Soyadı *</div><input value={form.last_name} onChange={e=>setForm(f=>({...f,last_name:e.target.value}))} style={inp} required/></div>
                  <div><div style={lbl}>T.C. No</div><input value={form.tc_no} onChange={e=>setForm(f=>({...f,tc_no:e.target.value}))} style={inp} maxLength={11}/></div>
                  <div><div style={lbl}>Doğum Tarihi</div><input type="date" value={form.birth_date} onChange={e=>setForm(f=>({...f,birth_date:e.target.value}))} style={inp}/></div>
                  <div><div style={lbl}>Telefon</div><input value={form.phone} onChange={e=>setForm(f=>({...f,phone:e.target.value}))} style={inp}/></div>
                  <div><div style={lbl}>E-posta</div><input type="email" value={form.email} onChange={e=>setForm(f=>({...f,email:e.target.value}))} style={inp}/></div>
                  <div style={{gridColumn:'1/-1'}}><div style={lbl}>Adres</div><input value={form.address} onChange={e=>setForm(f=>({...f,address:e.target.value}))} style={inp}/></div>
                </div>
              </div>
              <div style={{marginBottom:12}}>
                <div style={{fontSize:11,color:'var(--text3)',fontWeight:600,textTransform:'uppercase',marginBottom:8}}>İş Bilgileri</div>
                <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:10}}>
                  <div><div style={lbl}>Pozisyon</div><input value={form.position} onChange={e=>setForm(f=>({...f,position:e.target.value}))} style={inp}/></div>
                  <div><div style={lbl}>Departman</div><input value={form.department} onChange={e=>setForm(f=>({...f,department:e.target.value}))} style={inp}/></div>
                  <div><div style={lbl}>İşe Giriş</div><input type="date" value={form.start_date} onChange={e=>setForm(f=>({...f,start_date:e.target.value}))} style={inp}/></div>
                  <div><div style={lbl}>Maaş</div><input type="number" value={form.salary} onChange={e=>setForm(f=>({...f,salary:e.target.value}))} style={inp} min="0" step="0.01"/></div>
                  <div><div style={lbl}>Döviz</div><select value={form.salary_currency} onChange={e=>setForm(f=>({...f,salary_currency:e.target.value}))} style={inp}><option value="TRY">TRY</option><option value="USD">USD</option><option value="EUR">EUR</option></select></div>
                  <div><div style={lbl}>Durum</div><select value={form.status} onChange={e=>setForm(f=>({...f,status:e.target.value}))} style={inp}><option value="active">Aktif</option><option value="passive">Pasif</option><option value="left">Ayrıldı</option></select></div>
                </div>
              </div>
              <div style={{marginBottom:12}}>
                <div style={{fontSize:11,color:'var(--text3)',fontWeight:600,textTransform:'uppercase',marginBottom:8}}>Finansal & Acil</div>
                <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:10}}>
                  <div><div style={lbl}>Banka</div><input value={form.bank_name} onChange={e=>setForm(f=>({...f,bank_name:e.target.value}))} style={inp}/></div>
                  <div style={{gridColumn:'span 2'}}><div style={lbl}>IBAN</div><input value={form.iban} onChange={e=>setForm(f=>({...f,iban:e.target.value}))} style={inp}/></div>
                  <div><div style={lbl}>Acil İletişim</div><input value={form.emergency_name} onChange={e=>setForm(f=>({...f,emergency_name:e.target.value}))} style={inp}/></div>
                  <div><div style={lbl}>Acil Telefon</div><input value={form.emergency_phone} onChange={e=>setForm(f=>({...f,emergency_phone:e.target.value}))} style={inp}/></div>
                  <div style={{gridColumn:'1/-1'}}><div style={lbl}>Notlar</div><textarea value={form.notes} onChange={e=>setForm(f=>({...f,notes:e.target.value}))} style={{...inp,height:50,resize:'vertical',paddingTop:8}}/></div>
                </div>
              </div>
              <div style={{display:'flex',gap:8}}>
                <button type="submit" disabled={saving} className="btn btn-dark">{saving?'Kaydediliyor...':'Kaydet'}</button>
                <button type="button" onClick={()=>setShowForm(false)} className="btn btn-ghost">İptal</button>
              </div>
            </form>
          </div>
        )}

        {/* Personel Detay */}
        {selected && !showForm && (
          <>
            <div className="card">
              <div style={{display:'flex',alignItems:'center',justifyContent:'space-between'}}>
                <div style={{display:'flex',alignItems:'center',gap:12}}>
                  <div style={{width:42,height:42,borderRadius:'var(--radius-lg)',background:'var(--blue-bg)',border:'1px solid var(--blue-border)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:14,fontWeight:600,color:'var(--blue-light)'}}>
                    {selected.first_name?.[0]}{selected.last_name?.[0]}
                  </div>
                  <div>
                    <div style={{fontSize:15,fontWeight:600}}>{selected.first_name} {selected.last_name}</div>
                    <div style={{fontSize:12,color:'var(--text3)',marginTop:2}}>
                      {selected.position||'—'}{selected.department?` · ${selected.department}`:''} · {selected.phone||'—'}
                    </div>
                  </div>
                </div>
                <div style={{display:'flex',gap:6}}>
                  <button onClick={()=>setShowPayForm(!showPayForm)} className="btn btn-green btn-sm">💰 Maaş Öde</button>
                  <button onClick={()=>openEdit(selected)} className="btn btn-ghost btn-sm">Düzenle</button>
                  <button onClick={()=>deleteStaff(selected.id)} className="btn btn-sm" style={{background:'var(--red-bg)',color:'var(--red)',border:'1px solid var(--red-border)'}}>Sil</button>
                </div>
              </div>
              <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:10,marginTop:14}}>
                {[
                  ['Maaş', selected.salary ? fmt(selected.salary) : '—'],
                  ['İşe Giriş', fmtDate(selected.start_date)],
                  ['IBAN', selected.iban||'—'],
                  ['Durum', selected.status==='active'?'Aktif':selected.status==='passive'?'Pasif':'Ayrıldı'],
                ].map(([l,v]) => (
                  <div key={l} style={{background:'var(--bg3)',borderRadius:'var(--radius)',padding:'8px 10px'}}>
                    <div style={{fontSize:10,color:'var(--text3)',marginBottom:2}}>{l}</div>
                    <div style={{fontSize:13,fontWeight:500}}>{v}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* Ödeme formu */}
            {showPayForm && (
              <div className="card">
                <div style={{fontSize:13,fontWeight:600,marginBottom:12}}>💰 Maaş Ödemesi</div>
                <form onSubmit={addPayment}>
                  <div style={{display:'flex',gap:8,flexWrap:'wrap',alignItems:'flex-end'}}>
                    <div><div style={lbl}>Tutar *</div><input type="number" value={payForm.amount} onChange={e=>setPayForm(f=>({...f,amount:e.target.value}))} style={{...inp,width:140}} required min="0" step="0.01"/></div>
                    <div><div style={lbl}>Dönem</div><input value={payForm.period} onChange={e=>setPayForm(f=>({...f,period:e.target.value}))} style={{...inp,width:120}} placeholder="Haziran 2026"/></div>
                    <div><div style={lbl}>Tarih *</div><input type="date" value={payForm.pay_date} onChange={e=>setPayForm(f=>({...f,pay_date:e.target.value}))} style={{...inp,width:150}} required/></div>
                    <div style={{flex:1}}><div style={lbl}>Not</div><input value={payForm.notes} onChange={e=>setPayForm(f=>({...f,notes:e.target.value}))} style={inp}/></div>
                    <button type="submit" disabled={saving} className="btn btn-green">{saving?'...':'Öde'}</button>
                    <button type="button" onClick={()=>setShowPayForm(false)} className="btn btn-ghost">İptal</button>
                  </div>
                </form>
              </div>
            )}

            {/* Ödeme geçmişi */}
            <div className="card">
              <div style={{fontSize:13,fontWeight:600,marginBottom:12}}>Maaş Ödemeleri</div>
              {payments.length===0 ? <div style={{textAlign:'center',padding:'1rem',color:'var(--text3)',fontSize:12}}>Ödeme yok.</div> : (
                <table style={{width:'100%',borderCollapse:'collapse',fontSize:13}}>
                  <thead><tr style={{borderBottom:'1px solid var(--border)'}}>
                    {['Tarih','Dönem','Tutar','Not',''].map(h=><th key={h} style={{padding:'6px 0',fontSize:10,color:'var(--text3)',fontWeight:500,textAlign:'left',textTransform:'uppercase'}}>{h}</th>)}
                  </tr></thead>
                  <tbody>
                    {payments.map(p=>(
                      <tr key={p.id} style={{borderBottom:'1px solid var(--border2)'}}>
                        <td style={{padding:'8px 0'}}>{fmtDate(p.pay_date)}</td>
                        <td style={{padding:'8px 0',color:'var(--text3)'}}>{p.period||'—'}</td>
                        <td style={{padding:'8px 0',fontWeight:600,color:'var(--green)'}}>{fmt(p.amount)}</td>
                        <td style={{padding:'8px 0',color:'var(--text3)',fontSize:12}}>{p.notes||'—'}</td>
                        <td style={{padding:'8px 0'}}>
                          <button onClick={()=>deletePayment(p.id)} style={{width:24,height:24,border:'1px solid var(--red-border)',borderRadius:'var(--radius)',background:'var(--red-bg)',color:'var(--red)',cursor:'pointer',fontSize:13}}>×</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </>
        )}

        {!selected && !showForm && (
          <div className="card" style={{textAlign:'center',padding:'3rem',color:'var(--text3)'}}>
            
            <div style={{fontSize:13}}>Listeden bir personel seçin veya yeni personel ekleyin.</div>
          </div>
        )}
      </div>
    </div>
  );
}
